import React from "react";

import { grid } from "./ArrowButtonGrid.module.scss";

export const ArrowButtonGrid = ({ children }) => {
  return <div className={grid}>{children}</div>;
};
